// EventCard.js
import React, { useState } from 'react';
import '../styles/LittleChiefStyle.css';
import closeIconSrc from '../static/images/icons8-close-50.png';


const EventCard = ({ event }) => {
    const {
        event_name,
        event_description,
        event_image_url,
        event_date,
        event_artists,
    } = event;

    const formattedDate = new Date(event_date).toLocaleDateString();
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <div className="event-card">
                {event_image_url && (
                    <div class="image-container">
                    <img
                        className="event-card__image"
                        src={event_image_url}
                        alt={event_name}
                        onClick={() => setIsOpen(true)}
                    />
                    </div>
                )}
                <div className="event-card__content">
                    <h2 className="event-card__title">{event_name}</h2>
                    <p>{event_description}</p>
                    <p><strong>Date:</strong> {formattedDate}</p>
                    {event_artists?.length > 0 && (
                        <div className="event-card__artists">
                            <h3>Artists:</h3>
                            <ul>
                                {event_artists.map((a,i) => (
                                    <li key={i}><strong>{a.role}</strong>: {a.artist_name}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>

            {isOpen && (
                <div className="lightbox" onClick={() => setIsOpen(false)}>
                    <div className="lightbox-content" onClick={e => e.stopPropagation()}>
                        <button className="lightbox-close" onClick={() => setIsOpen(false)}>
                            <img
                                src={closeIconSrc}
                                alt="Close preview"
                                className="lightbox-close-icon"
                            />
                        </button>
                        <img
                            className="lightbox-image"
                            src={event_image_url}
                            alt={event_name}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default EventCard;
